
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppLayout from "./layouts/AppLayout";
import PricingRuleContainer from "./modules/PricingRules/PricingRuleContainer";
import CreatePricingRule from "./modules/PricingRules/components/CreatePricingRule";
import PriceSimulator from "./modules/PricingRules/components/PricingRuleSimulator";
import LiquidationSaleContainer from "./modules/LiquidationSale/LiquidationSaleContainer";
import DiscountContainer from "./modules/Discounts/DiscountContainer";
import SortOrderContainer from "./modules/SortOrder/SortOrderContainer";
import AuditContainer from "./modules/Audit/AuditContainer";
import NotFound from "./components/NotFound";
import RoleGuard from "./components/RoleGuard";
import { ROLES } from "./utils/roles";

function App() {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AppLayout />}>
          <Route
            path=""
            element={
              <RoleGuard allowedRoles={[ROLES.PRICING_USER]}>
                <PricingRuleContainer />
              </RoleGuard>
            }
          />
          <Route
            path="pricing-rules/create"
            element={
              <RoleGuard allowedRoles={[ROLES.PRICING_USER]}>
                <CreatePricingRule />
              </RoleGuard>
            }
          />
          <Route
            path="pricing-rules/:id"
            element={
              <RoleGuard allowedRoles={[ROLES.PRICING_USER]}>
                <CreatePricingRule />
              </RoleGuard>
            }
          />
          <Route
            path="pricing-rule-simulator"
            element={
              <RoleGuard allowedRoles={[ROLES.PRICING_USER, ROLES.STORE_MANAGER]}>
                <PriceSimulator />
              </RoleGuard>
            }
          />
          <Route
            path="liquidation-sale-products"
            element={
              <RoleGuard allowedRoles={[ROLES.STORE_MANAGER]}>
                <LiquidationSaleContainer />
              </RoleGuard>
            }
          />
          <Route
            path="liquidation-sale-discount"
            element={
              <RoleGuard allowedRoles={[ROLES.PRICING_USER]}>
                <DiscountContainer />
              </RoleGuard>
            }
          />
          <Route
            path="flash-sale-product-sort-order"
            element={
              <RoleGuard allowedRoles={[ROLES.PRICING_USER]}>
                <SortOrderContainer />
              </RoleGuard>
            }
          />
          <Route
            path="audit"
            element={
              <RoleGuard allowedRoles={[ROLES.RULE_AUDIT]}>
                <AuditContainer />
              </RoleGuard>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
